interface PeopleIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function PeopleIcon({ 
  size = 14, 
  color = '#4D5762',
  className = '' 
}: PeopleIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill={color}
      className={className}
    >
      <path
        d="M9.91667 12.25V11.0833C9.91667 10.4645 9.67083 9.871 9.23325 9.43342C8.79567 8.99583 8.20217 8.75 7.58333 8.75H2.91667C2.29783 8.75 1.70434 8.99583 1.26675 9.43342C0.829166 9.871 0.583332 10.4645 0.583332 11.0833V12.25M13.4167 12.25V11.0833C13.4163 10.5669 13.2485 10.0649 12.9388 9.65234C12.6291 9.23977 12.1943 8.93918 11.6975 8.79583M9.36417 1.79583C9.86224 1.93843 10.2984 2.23899 10.609 2.65211C10.9197 3.06523 11.0878 3.56823 11.0878 4.08542C11.0878 4.6026 10.9197 5.1056 10.609 5.51872C10.2984 5.93184 9.86224 6.2324 9.36417 6.375M7.58333 4.08333C7.58333 5.37199 6.53866 6.41667 5.25 6.41667C3.96134 6.41667 2.91667 5.37199 2.91667 4.08333C2.91667 2.79467 3.96134 1.75 5.25 1.75C6.53866 1.75 7.58333 2.79467 7.58333 4.08333Z"
      />
    </svg>
  );
}
